import React, { FC, useEffect, useState } from "react";
import { useAuth, hasAuthParams } from "react-oidc-context";
import { useHistory } from "react-router-dom";
import ReactGA from "react-ga4";
import FixedLoader from "components/FixedLoader";
import Routes from "./routes";
import { useAuthContext } from "context/AuthContext";
import { RequestACallProvider } from "components/RequestACall";

const allowLogin = () => {
  const url = window.location.href;
  if (url.includes("/auth/callback")) return false;
  if (url.includes("/auth/complete-profile")) return false;
  if (url.includes("/download")) return false;
  if (url.includes("/terms")) return false;
  if (url.includes("/privacy")) return false;
  if (url.includes("/migrations")) return false;
  if (url.includes("/locallogout")) return false;
  if (url.includes("/analyst")) return false;
  if (url.includes("/plans")) return false;
  return true;
}

let isDone = false;
const App: FC = () => {
  const { isAuthenticated, isLoading, activeNavigator, error, signinRedirect, user, signinSilent, events, removeUser, revokeTokens, clearStaleState, signoutSilent } = useAuth();
  const [loading, setLoading] = useState(false);
  const { removeUserInfo } = useAuthContext();
  const history = useHistory();

  // Automatically sign-in
  useEffect(() => {
    // Remove OLD Refresh Token
    localStorage.removeItem("refreshToken");
    if (error?.message?.includes("login_required")) return;
    if (!hasAuthParams() && !isAuthenticated && !activeNavigator && !isLoading) {
      if (allowLogin()) {
        isDone = true;
        signinRedirect({ prompt: "none" });
      }
    }
  }, [isAuthenticated, activeNavigator, isLoading, signinRedirect, error?.message]);


  // useEffect(() => {
  //   // make renew manually
  //   return events.addAccessTokenExpiring(() => {
  //     signinSilent().catch(e => console.log("addAccessTokenExpiring", e));
  //   });
  // }, [events, signinSilent]);

  // useEffect(() => {
  //   console.log({ isDone, isAuthenticated });
  //   if (isAuthenticated && !isDone) {
  //     const url = window.location.href;
  //     if (!(url.includes("code="))) {
  //       isDone = true;
  //       setLoading(true);
  //       console.log("Silent Login Called!");
  //       signinSilent().finally(() => {
  //         setLoading(false);
  //       })
  //     }
  //   }
  // }, [isAuthenticated, isDone, events])

  /**
  * Check Session & Logout
  * https://brockallen.com/2016/08/12/check-session-support-in-oidc-client-js
  * Called on OP Signed Out
  */
  const handleAutoLogout = () => {
    removeUserInfo();
    signoutSilent();
    history.replace("/");
  }

  useEffect(() => {
    events.addUserSignedOut(handleAutoLogout);
    return () => {
      events.removeUserSignedOut(handleAutoLogout);
    }
  }, []);
  console.log({ isLoading, loading })
  if (isLoading || loading) return <FixedLoader />;
  return (
    <RequestACallProvider>
      <Routes />
    </RequestACallProvider>
  )
};

export default App;
